<template>
  <div class="com-bottom-footer">
    <div class="entry-qrcode fc">
      <!-- 入口列表 -->
      <div class="entry-list fc">
        <div class="entry-list-item" v-for="item in routes" :key="item.path">
          <div class="item-title">{{ item.meta.title }}</div>
          <ul class="item-list">
            <!-- <li >首页</li> -->
            <li v-for="ktem in item.children" :key="ktem.path">
              <router-link :to="{ name: ktem.name }">{{ ktem.meta.title }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- 二维码 -->
       <div class="qrcode fb">
        <div class="qr-item">
          <img :src="qiye_qrcode" :alt="$t('enterpriseWeChat')">
          <div>{{ $t('enterpriseWeChat') }}</div>
        </div>
        <div class="qr-item">
          <img :src="wechat_qrcode" :alt="$t('ConsultationQrCode')">
          <div>{{ $t('ConsultationQrCode') }}</div>
        </div>
       </div>
    </div>
    <!-- 版权 -->
    <div class="copyright" @click="toCopyRight">Copyright © 2022 56carrier.com ALL Rights Reserved 粤ICP备2021045320号</div>
  </div>
</template>

<script setup>
const qiye_qrcode = require('@assets/images/qrcode-qiye.png')
const wechat_qrcode = require('@assets/images/qrcode-wechat.png')
import { routes } from '@/router'
const toCopyRight = () => {
  window.open('https://beian.miit.gov.cn', '_blank');
}
</script>

<style lang="less" scoped>
.com-bottom-footer {
  .entry-qrcode {
    background-color: #222B33;
    color: #FFFFFF;
    flex-wrap: wrap;
    padding: 39px 0 34px 0;
    align-items: flex-start;
    .entry-list {
      gap: 73px;
      align-items: flex-start;
      .entry-list-item {
        .item-title {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 20px;
        }
        ul.item-list {
          li {
            color: #858B90;
            font-size: 12px;
            font-weight: 400;
            margin-bottom: 16px;
            a {
              color: #858B90;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .qrcode {
      margin-left: 118px;
      gap: 51px;
      .qr-item {
        text-align: center;
        img {
          width: 120px;
          height: 120px;
        }
        div {
          font-size: 14px;
          margin-top: 13px;
        }
      }
    }
  }
  
  .copyright {
    background-color: #161C22;
    padding: 19px 0;
    text-align: center;
    color: #949494;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>